// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});


export function KZD_mouseIn(event) {
	$w("#statebox8").expand (); 
        $w("#statebox8").changeState("stateKZD")
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

export function button10_mouseIn(event) {
	$w("#statebox8").expand (); 
        $w("#statebox8").changeState("ReginalProc")
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}



export function button11_mouseIn(event) {
	$w("#statebox8").expand (); 
        $w("#statebox8").changeState("LocalJudge")
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

export function button9_mouseIn(event) {
	$w("#statebox8").expand (); 
        $w("#statebox8").changeState("ReginalDirection")
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}